import { createActions } from 'redux-actions';

export const {
  loadSubscriptionsSuccess,
  initIosProducts,
  initIosRequest,
  errorIosRequest
} = createActions(
  'LOAD_SUBSCRIPTIONS_SUCCESS',
  'INIT_IOS_PRODUCTS',
  'INIT_IOS_REQUEST',
  'ERROR_IOS_REQUEST'
);
